import React from "react";

function Training() {
  return <div>{/* Empty DOM */}</div>;
}

export default Training;
